import { createSlice } from '@reduxjs/toolkit';
const patternSlice = createSlice({ name: 'pattern', initialState: {} });
export default patternSlice.reducer;
